import Footer from '@react/shared/components/Footer';
import Header from '@react/shared/components/Header/Header.container';
import Helmet from 'next/head';
import { StrictMode, useEffect } from 'react';
import { LegalPageProps } from 'sly/legalPage/legalPage.types';
import LegalPageContent from 'sly/legalPage/LegalPageContent';
import LegalPageHeader from 'sly/legalPage/legalPageHeader';
import { pageNames, useEvents } from 'sly/services/events';

export default function LegalPage({ legalPage }: LegalPageProps) {
  const { events } = useEvents();
  useEffect(() => {
    events.page(pageNames.Legal, {});
  }, []);

  return (
    <StrictMode>
      <Helmet>
        <title>Find The Best Senior Living Options Near You | Seniorly</title>
        <meta name='robots' content='noindex' />
      </Helmet>
      <header>
        <Header />
      </header>
      <LegalPageHeader legalPage={legalPage} />
      <LegalPageContent legalPage={legalPage} />
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*@ts-ignore*/}
      <Footer />
    </StrictMode>
  );
}
